import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import classNames from 'classnames';

import { Field, reduxForm, SubmissionError } from 'redux-form';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';

import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroupField from 'components/fields/RadioGroupField';

import IconCheck from 'components/icons/IconCheck';
import IconStarOutline from 'components/icons/IconStarOutline';

import Section, { SectionHeader, SectionTitle, SectionBody, SectionFooter } from 'components/common/Section';
import Button from 'components/common/Button';
import Link from 'components/common/Link';

import hexToRgb from 'styles/hexToRgb';
import pxToRem from 'styles/pxToRem';

import dateFormat from 'config/dateFormat';
import formatPrice from 'utils/formatPrice';

const styles = theme => ({
  sectionBody: {
    padding: '60px 80px',
  },
  typographyTitle: {
    padding: '12px 0',
    marginBottom: 28,
    borderBottom: `1px solid ${theme.palette.primary.A100}`,
  },
  button: {
    marginTop: 20,
  },
  formControlLabel: {
  },
  formControlRoot: {
    // borderTop: `1px solid ${theme.palette.primary.A100}`,
  },
  radioGroupFieldRoot: {
    '& label': {
      position: 'relative',
      // marginTop: 24,
      paddingTop: 12,
      width: '33.33%',
      alignItems: 'flex-start',
      justifyContent: 'center',
      marginRight: 0,
    },
    '&:before': {
      display: 'block',
      content: '""',
      position: 'absolute',
      left: -20,
      top: '50%',
      width: 20,
      height: 20,
      marginTop: 10,
      background: theme.palette.common.white,
    },
  },
  formControlRadio: {
    marginTop: -12,
  },


  typographySubtitle: {
    marginBottom: 24,
  },
  gridHeader: {
    marginTop: 0,
    marginBottom: 0,
  },
  gridService: {
    borderTop: `1px solid ${theme.palette.primary.A100}`,
    marginTop: 0,
    marginBottom: 0,
  },
  gridItemRecommended: {
    backgroundColor: `rgba(${hexToRgb(theme.palette.primary[500])}, 0.20)`,
  },
  price: {
    fontSize: pxToRem(26),
  },
  buttonSelect: {
    display: 'block',
    width: '100%',
  },
  typographyRecommended: {
    fontSize: pxToRem(12),
    backgroundColor: theme.palette.notification[900],
    color: theme.palette.common.white,
    padding: '6px 0',
    margin: '0 12px 0 12px',
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    verticalAlign: 'middle',
  },
  iconStarOutline: {
    width: 14,
    height: 14,
    verticalAlign: 'middle',
    margin: '-2px 4px 0 0',
  },
  iconCheck: {
    width: 12,
    height: 12,
    padding: 4,
    color: theme.palette.primary[500],
    backgroundColor: `rgba(${hexToRgb(theme.palette.primary[500])}, 0.20)`,
    borderRadius: '50%',
  },
  typographyService: {
    marginTop: 4,
    marginBottom: 4,
  },
  typographyServiceValue: {
    marginTop: 4,
    marginBottom: 4,
  },
  gridServiceItemLabel: {
    display: 'flex',
    alignItems: 'center',
  },
  gridServiceItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
});


const PaymentCurrentSubscription = ({ business, paymentPlans, onEditButtonClick, classes }) => {
  const highestPlan = paymentPlans.reduce((accumulator, currentValue) => {
    if (currentValue['Is Fake']) {
      return accumulator;
    }
    if (!accumulator || accumulator['Stripe Price']['Unit Amount'] < currentValue['Stripe Price']['Unit Amount']) {
      return currentValue;
    }
    return accumulator;
  }, null);
  return (
    <Section>
      <SectionHeader fixed>
        <SectionTitle>
          Current Subscription
        </SectionTitle>
      </SectionHeader>
      <SectionBody className={classes.sectionBody}>
        <Grid
          container
          spacing={24}
          alignItems="center"
        >
          <Grid item>
            <div className={classes.subscription}>
              <Grid
                container
                spacing={24}
                alignItems="center"
              >
                <Grid item>
                  <Typography>
                    <IconCheck className={classes.iconCheck} />
                    Your subscription is active - next payment on {business['Company Subscription Payment']['Last Finished Payment']['Payed To']}
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography variant="subheading">
                    {business['Company Subscription Payment']['Last Finished Payment']['Stripe Product'].Name}
                  </Typography>
                </Grid>
                {(business['Company Subscription Payment']['Last Finished Payment']['Stripe Product']['Stripe Price']
                  && business['Company Subscription Payment']['Last Finished Payment']['Stripe Product']['Stripe Price']['Unit Amount']) &&
                  <Grid item>
                    <Typography variant="subheading">
                        {formatPrice(business['Company Subscription Payment']['Last Finished Payment']['Stripe Product']['Stripe Price']['Unit Amount'])}
                    </Typography>
                  </Grid>
                }
                <Grid item>
                  <Link
                    size="sm"
                    underline
                    href="/settings/payment/plan-details"
                  >
                    Plan Details
                  </Link>
                </Grid>
              </Grid>
            </div>
          </Grid>
          <Grid item>
            <Link
              size="md"
              color="primary"
              target="_blank"
              download={`${business.Agreement['File Url']}${business.Agreement['File Name']}`}
              href={`${business.Agreement['File Url']}${business.Agreement['File Name']}`}
            >
              Download Contract
            </Link>
          </Grid>
        </Grid>
        <Grid
          container
          spacing={24}
          alignItems="center"
        >      
          {highestPlan.ID !== business['Company Subscription Payment']['Last Finished Payment']['Stripe Product'] &&
            <Grid item>
              <Link
                size="md"
                color="primary"
                onClick={onEditButtonClick}
              >
                Upgrade
              </Link>
            </Grid>
          }
          <Grid item>
            <Link
              disabled
              size="md"
              color="validation"
              onClick={() => {
                // change('Payment Plan ID', null);
                // setTimeout(() => {
                //   submit();
                //   this.setState({ edit: true });
                // }, 200);
              }}
            >
              Cancel
            </Link>
          </Grid>
        </Grid>
      </SectionBody>
    </Section>
  );
};

PaymentCurrentSubscription.propTypes = {
  ID: PropTypes.number,
  'Name on Card': PropTypes.string,
  'Card Number': PropTypes.string,
  'Payment Plan ID': PropTypes.number,
  Payments: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.string,
  })),
  onEditButtonClick: PropTypes.func,
  classes: PropTypes.shape({
    sectionBody: PropTypes.string.isRequired,
    typographyTitle: PropTypes.string.isRequired,
    button: PropTypes.string.isRequired,
    radioGroupFieldRoot: PropTypes.string.isRequired,
    formControlLabel: PropTypes.string.isRequired,
    formControlRoot: PropTypes.string.isRequired,
    subscription: PropTypes.string.isRequired,
    iconCheck: PropTypes.string.isRequired,
  }).isRequired,
};

PaymentCurrentSubscription.defaultProps = {
  ID: null,
  'Name on Card': '',
  'Card Number': '',
  Payments: [],
  'Payment Plan ID': null,
  onSelect: () => {},
};

export default withStyles(styles)(PaymentCurrentSubscription);



// WEBPACK FOOTER //
// ./src/components/settings/PaymentCurrentSubscription/PaymentCurrentSubscription.js